<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <InformationApprentiSection />
  <CoordonneesApprentiSection />
  <SituationApprentiSection />
  <RepresentantLegalSection />
  <CoordonneesRepresentantLegalSection />
  <MaitreApprentissageSection />
</template>

<script setup lang="ts">
  import CoordonneesApprentiSection from './sections/coordonneesApprenti/CoordonneesApprentiSection.vue'
  import CoordonneesRepresentantLegalSection from './sections/coordonneesRepresentantLegal/CoordonneesRepresentantLegalSection.vue'
  import InformationApprentiSection from './sections/informationApprenti/InformationApprentiSection.vue'
  import MaitreApprentissageSection from './sections/maitreApprentissage/MaitreApprentissageSection.vue'
  import RepresentantLegalSection from './sections/representantLegal/RepresentantLegalSection.vue'
  import SituationApprentiSection from './sections/situationApprenti/SituationApprentiSection.vue'
</script>
